import {    Injectable          } from '@angular/core';

import {    TranslateHttpLoader } from '@ngx-translate/http-loader';
import {    HttpClient          } from '@angular/common/http';
import {    SessionManager      } from '../session/session.manager';

import {    isSessionCode  , 
            SessionCode         } from 'src/app/enums/session/session-code.enum';

import {    TranslateService, MissingTranslationHandler, MissingTranslationHandlerParams    } from '@ngx-translate/core';
import { AvailableLanguage } from 'src/app/enums/language/available-language.enum';

@Injectable({
  providedIn: 'root'
})
export class LanguageManager {

    constructor(
        private sessionManager  : SessionManager    ,
        private translate       : TranslateService  ,
    ) { }

    initLanguage () 
    {
        this.translate.addLangs([
            //AvailableLanguage.ENGLISH,
            AvailableLanguage.ITALIAN
        ])

        this.recovery()
    }

    recovery()
    {        
        let language: any = this.sessionManager.language().get()        
        if(isSessionCode(language))
        {
            switch (language) {
                case SessionCode.GENERIC        : 
                    this.setLanguage ( AvailableLanguage.DEFAULT )
                break
                case SessionCode.MISSING_VALUE  : 
                    this.setLanguage ( this.translate.getBrowserLang() as any )
                break
                default:
                    this.setLanguage ( this.translate.getBrowserLang() as any )
                break
            }
        }else
        {
            this.setLanguage ( language )
        }
    }

    setLanguage ( language: AvailableLanguage ) 
    {
        switch(language)
        {
            case AvailableLanguage.ENGLISH:
                this.translate.setDefaultLang       ( AvailableLanguage.ENGLISH )
                this.sessionManager.language().set  ( AvailableLanguage.ENGLISH )
            break;
            case AvailableLanguage.ITALIAN:
                this.translate.setDefaultLang       ( AvailableLanguage.ITALIAN )
                this.sessionManager.language().set  ( AvailableLanguage.ITALIAN )
            break;
            case AvailableLanguage.DEFAULT:
                this.translate.setDefaultLang ( AvailableLanguage.DEFAULT )
            break;
            default: 
                this.translate.setDefaultLang ( AvailableLanguage.DEFAULT )
            break;
        }
        
    }

}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/');
}

  